module.exports = __webpack_public_path__ + "img/download-and-install.64bc1a21.png";